module.exports = __webpack_public_path__ + "img/landing.a714b1be.jpg";